// extracted by mini-css-extract-plugin
export var active = "_60-a";
export var activeIndicator = "_60-9";
export var disabled = "_60-b";
export var fullWidth = "_60-2";
export var lg = "_60-7";
export var md = "_60-6";
export var redoButtonTabGroup = "_60-0";
export var sm = "_60-5";
export var tabButton = "_60-4";
export var tabButtonsContainer = "_60-1";
export var themeDestructive = "_60-d";
export var themeNormal = "_60-c";
export var themeSuccess = "_60-e";
export var xl = "_60-8";
export var xs = "_60-3";